// AUTO-GENERATED by scripts/build-generators.mjs — do not edit by hand.
export const FANCY_STYLE_COUNT = 172;
